import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';
import Backgrounder from 'components/Backgrounder';

import styles from './styles.scss';

const CONTENT_KEYS = {
  filtration: 'Water Filtration',
};

const Filtration = ({
  content: {
    filtration: {
      fields: { title, description, images },
    },
  },
}) => {
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        const id = get(node, 'data.target.sys.contentType.sys.id');

        switch (id) {
          case 'button':
            return (
              <Button
                className={styles.btn}
                document={node.data.target}
                to={node.data.target.fields.link}
              >
                {children}
              </Button>
            );
          default:
            return null;
        }
      },
    },
  };

  return (
    <Backgrounder className={styles.filtration}>
      <div>
        <h2>{title}</h2>
        {documentToReactComponents(description, options)}
      </div>
      <div className={styles.imageContainer}>
        <img
          src={`${images[0].fields.file.url}?fm=webp`}
          alt={images[0].fields.description}
        />
      </div>
    </Backgrounder>
  );
};

Filtration.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEYS)(Filtration);
